import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import NotificationBell from './NotificationBell';
import ToastNotification from './ToastNotification';
import CkbLogo from './CkbLogo';
import { useTheme } from '../context/ThemeContext';

function ThemeToggle() {
  const { dark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      className="relative p-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white focus:outline-none transition-colors"
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className="text-xl">{dark ? '☀️' : '🌙'}</span>
    </button>
  );
}

export default function Layout() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-200">
      {!isMobile && <Sidebar />}

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top bar */}
        <div className="bg-white dark:bg-gray-800 shadow-sm dark:shadow-gray-900/50 px-4 lg:px-6 py-3 flex items-center justify-between transition-colors duration-200">
          {isMobile && (
            <CkbLogo size={32} showText textClassName="text-lg font-bold text-gray-800 dark:text-white" />
          )}
          <div className={`flex items-center gap-1 ${isMobile ? '' : 'ml-auto'}`}>
            <ThemeToggle />
            <NotificationBell />
          </div>
        </div>

        {/* Main content */}
        <main className={`flex-1 overflow-y-auto p-4 lg:p-8 ${isMobile ? 'pb-20' : ''}`}>
          <Outlet />
        </main>

        <ToastNotification />
      </div>

      {isMobile && <BottomNav />}
    </div>
  );
}
